import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'Components/Modal';
import Icon from 'Components/Icon';
import EnvironmentManager from 'Utils/environmentManager';
import { getVideoPosterSrc, isDirectVideoUrl, toVideoEmbedSrc } from 'Utils/videoEmbedSrc';
import {
  FAST_DEPOSIT_PAGE_CLICK_POINT,
  trackClickPlayButtonOnHowToDepositBottomsheet
} from 'Utils/lowBalanceFastDeposit';

const cms = key => EnvironmentManager.messages?.find(item => item?.key === key)?.value ?? '';

const withAutoplay = url => {
  if (!url) return url;
  if ((/[?&]autoplay=/).test(url)) return url;
  return `${url}${url.includes('?') ? '&' : '?'}autoplay=1`;
};

const HowToDepositSheet = ({
  isOpen,
  onClose,
  onboardingImage,
  clickPoint = FAST_DEPOSIT_PAGE_CLICK_POINT
}) => {
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setIsPlaying(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const title = cms('bilyoner_aninda_how_to_title');
  const description = cms('bilyoner_aninda_how_to_description');
  const okButton = cms('bilyoner_aninda_detail_OK_button') || 'Anladım';
  const videoUrl = toVideoEmbedSrc(cms('bilyoner_aninda_onboarding_video_url'));
  const posterSrc = getVideoPosterSrc(videoUrl);
  const showVideo = !!videoUrl;
  const useVideoElement = isDirectVideoUrl(videoUrl);

  const handlePlayClick = () => {
    trackClickPlayButtonOnHowToDepositBottomsheet(clickPoint);
    setIsPlaying(true);
  };

  return (
    <Modal
      isOpen
      onClose={ onClose }
      position={ { web: 'center' } }
      className="fast-deposit-modal"
    >
      <div className="fast-deposit-how-to">
        <div className="fast-deposit-how-to__header">
          <h2 className="fast-deposit-how-to__title">{ title }</h2>
          <button
            type="button"
            className="fast-deposit-how-to__close"
            onClick={ onClose }
          >
            <Icon iconName="svgFastDepositClose" />
          </button>
        </div>

        { description && (
          <p
            className="fast-deposit-how-to__description"
            dangerouslySetInnerHTML={ { __html: description } }
          />
        ) }

        { onboardingImage && (
          <img
            src={ onboardingImage }
            alt="Nasıl yatırılır"
            className="fast-deposit-how-to__image"
          />
        ) }

        { showVideo && (
          <div className="fast-deposit-how-to__video">
            <div className="fast-deposit-how-to__video-frame">
              { /* eslint-disable-next-line no-nested-ternary */ }
              { isPlaying ? (
                useVideoElement ? (
                  <video
                    src={ videoUrl }
                    title="Hızlı para yatırma"
                    controls
                    playsInline
                    autoPlay
                  />
                ) : (
                  <iframe
                    src={ withAutoplay(videoUrl) }
                    title="Hızlı para yatırma"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                )
              ) : (
                <>
                  { posterSrc && (
                    <img
                      src={ posterSrc }
                      alt=""
                      className="fast-deposit-how-to__poster"
                    />
                  ) }
                  <button
                    type="button"
                    className="fast-deposit-how-to__play"
                    onClick={ handlePlayClick }
                    aria-label="Videoyu oynat"
                  >
                    <Icon iconName="svgPlay" className="fast-deposit-how-to__play-icon" />
                  </button>
                </>
              ) }
            </div>
          </div>
        ) }

        <button
          type="button"
          className="fast-deposit-how-to__ok-button"
          onClick={ onClose }
        >
          { okButton }
        </button>
      </div>
    </Modal>
  );
};

HowToDepositSheet.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onboardingImage: PropTypes.string,
  clickPoint: PropTypes.string
};

export default HowToDepositSheet;
